import React, { useState } from 'react';
import { Button } from './ui/button';
import { X, Menu } from 'lucide-react';

const Header = ({ t, currentLang, setLanguage, scrollToSection }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = (section) => {
    scrollToSection(section);
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-sm border-b border-slate-800">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-white">BiteSite</h1>
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className="text-slate-300 hover:text-white transition-colors duration-200"
            >
              {t.nav.services}
            </button>
            <button
              onClick={() => scrollToSection('why')}
              className="text-slate-300 hover:text-white transition-colors duration-200"
            >
              {t.nav.why}
            </button>
            <button
              onClick={() => scrollToSection('process')}
              className="text-slate-300 hover:text-white transition-colors duration-200"
            >
              {t.nav.process}
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-slate-300 hover:text-white transition-colors duration-200"
            >
              {t.nav.portfolio}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-slate-300 hover:text-white transition-colors duration-200"
            >
              {t.nav.contact}
            </button>
          </nav>

          {/* Language Switcher */}
          <div className="hidden md:flex items-center space-x-3 bg-slate-800/50 rounded-lg p-2 border border-slate-700">
            <button
              onClick={() => setLanguage('en')}
              className={`text-sm font-semibold transition-all duration-200 px-3 py-2 rounded flex items-center justify-center ${
                currentLang === 'en' 
                  ? 'bg-white/20 text-white' 
                  : 'text-slate-400 hover:text-white hover:bg-white/10'
              }`}
              title="English"
            >
              EN
            </button>
            <button
              onClick={() => setLanguage('fr')}
              className={`text-sm font-semibold transition-all duration-200 px-3 py-2 rounded flex items-center justify-center ${
                currentLang === 'fr' 
                  ? 'bg-white/20 text-white' 
                  : 'text-slate-400 hover:text-white hover:bg-white/10'
              }`}
              title="Français"
            >
              FR
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-slate-800 pt-4">
            <nav className="flex flex-col space-y-4">
              <button
                onClick={() => handleNavClick('services')}
                className="text-slate-300 hover:text-white transition-colors duration-200 text-left py-2"
              >
                {t.nav.services}
              </button>
              <button
                onClick={() => handleNavClick('why')}
                className="text-slate-300 hover:text-white transition-colors duration-200 text-left py-2"
              >
                {t.nav.why}
              </button>
              <button
                onClick={() => handleNavClick('process')}
                className="text-slate-300 hover:text-white transition-colors duration-200 text-left py-2"
              >
                {t.nav.process}
              </button>
              <button
                onClick={() => handleNavClick('portfolio')}
                className="text-slate-300 hover:text-white transition-colors duration-200 text-left py-2"
              >
                {t.nav.portfolio}
              </button>
              <button
                onClick={() => handleNavClick('contact')}
                className="text-slate-300 hover:text-white transition-colors duration-200 text-left py-2"
              >
                {t.nav.contact}
              </button>

              {/* Language Switcher for Mobile */}
              <div className="flex items-center space-x-3 bg-slate-800/50 rounded-lg p-2 border border-slate-700 mt-4">
                <button
                  onClick={() => setLanguage('en')}
                  className={`text-sm font-semibold transition-all duration-200 px-3 py-2 rounded flex items-center justify-center flex-1 ${
                    currentLang === 'en' 
                      ? 'bg-white/20 text-white' 
                      : 'text-slate-400 hover:text-white hover:bg-white/10'
                  }`}
                  title="English"
                >
                  EN
                </button>
                <button
                  onClick={() => setLanguage('fr')}
                  className={`text-sm font-semibold transition-all duration-200 px-3 py-2 rounded flex items-center justify-center flex-1 ${
                    currentLang === 'fr' 
                      ? 'bg-white/20 text-white' 
                      : 'text-slate-400 hover:text-white hover:bg-white/10'
                  }`}
                  title="Français"
                >
                  FR
                </button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
